/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

/* eslint-disable jsdoc/check-indentation */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* tslint:disable:typedef */


import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as Types from '../../types.generated';
export type ListApprovalsQueryVariables = Types.Exact<{
  userRole?: Types.Maybe<Types.ApprovalUserRole>;
  category?: Types.Maybe<Types.ApprovalCategory>;
  isActive?: Types.Maybe<Types.Scalars['Boolean']>;
  flowEnvironment?: Types.Maybe<Types.Scalars['String']>;
  status?: Types.Maybe<Types.Scalars['Int']>;
  additionalFilters?: Types.Maybe<Types.AdditionalFiltersInput>;
  approvalType?: Types.Maybe<Types.ApprovalRequestType>;
  extendedParameters?: Types.Maybe<Types.Scalars['ExtendedParameters']>;
  excludeThumbnails?: Types.Maybe<Types.Scalars['Boolean']>;
  pathBuilder?: Types.Maybe<Types.Scalars['PathBuilder']>;
}>;


export type ListApprovalsQuery = (
  { __typename?: 'QueryDefinition' }
  & { ListApprovals?: Types.Maybe<(
    { __typename?: 'ListApprovals' }
    & Pick<Types.ListApprovals, 'nextLink'>
    & { value?: Types.Maybe<Types.Maybe<(
      { __typename?: 'Approval' }
      & Pick<Types.Approval, 'name' | 'templateUrl' | 'detailsUrl'>
      & { properties?: Types.Maybe<(
        { __typename?: 'Properties' }
        & Pick<Types.Properties, 'isActive' | 'title' | 'result' | 'creationDate' | 'approvers' | 'type' | 'approvalType' | 'requestType' | 'category' | 'source' | 'priority' | 'templateId' | 'templateFormId' | 'templateResponseId'>
        & { owner?: Types.Maybe<(
          { __typename?: 'Principal' }
          & Pick<Types.Principal, 'id' | 'displayName' | 'thumbnailPhoto' | 'type'>
        )>; principals?: Types.Maybe<Types.Maybe<(
          { __typename?: 'Principal' }
          & Pick<Types.Principal, 'id' | 'displayName' | 'thumbnailPhoto' | 'type'>
        )>[]>; }
      )>; columns?: Types.Maybe<Types.Maybe<(
        { __typename?: 'Column' }
        & Pick<Types.Column, 'id' | 'displayText' | 'data'>
      )>[]>; selectors?: Types.Maybe<Types.Maybe<(
        { __typename?: 'Selector' }
        & Pick<Types.Selector, 'optionId' | 'displayText' | 'queryParameterKey'>
      )>[]>; }
    )>[]>; config?: Types.Maybe<(
      { __typename?: 'Config' }
      & { columns?: Types.Maybe<Types.Maybe<(
        { __typename?: 'ColumnConfig' }
        & Pick<Types.ColumnConfig, 'id' | 'type' | 'displayText' | 'minWidth' | 'maxWidth'>
      )>[]>; }
    )>; }
  )>; }
);


export const ListApprovalsDocument = gql`
    query ListApprovals($userRole: ApprovalUserRole, $category: ApprovalCategory, $isActive: Boolean, $flowEnvironment: String, $status: Int, $additionalFilters: AdditionalFiltersInput, $approvalType: ApprovalRequestType, $extendedParameters: ExtendedParameters, $excludeThumbnails: Boolean, $pathBuilder: PathBuilder) {
  ListApprovals(userRole: $userRole, category: $category, isActive: $isActive, flowEnvironment: $flowEnvironment, status: $status, additionalFilters: $additionalFilters, approvalType: $approvalType, extendedParameters: $extendedParameters, excludeThumbnails: $excludeThumbnails, pathBuilder: $pathBuilder) @rest(type: "ListApprovals", method: "GET", endpoint: $approvalType, pathBuilder: $pathBuilder) {
    value {
      name
      properties {
        isActive
        owner {
          id
          displayName
          thumbnailPhoto
          type
        }
        title
        result
        creationDate
        approvers
        principals {
          id
          displayName
          thumbnailPhoto
          type
        }
        type
        approvalType
        requestType
        category
        source
        priority
        templateId
        templateFormId
        templateResponseId
      }
      columns {
        id
        displayText
        data
      }
      selectors {
        optionId
        displayText
        queryParameterKey
      }
      templateUrl
      detailsUrl
    }
    config {
      columns {
        id
        type
        displayText
        minWidth
        maxWidth
      }
    }
    nextLink
  }
}
    `;

/**
 * __useListApprovalsQuery__
 *
 * To run a query within a React component, call `useListApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListApprovalsQuery({
 *   variables: {
 *      userRole: // value for 'userRole'
 *      category: // value for 'category'
 *      isActive: // value for 'isActive'
 *      flowEnvironment: // value for 'flowEnvironment'
 *      status: // value for 'status'
 *      additionalFilters: // value for 'additionalFilters'
 *      approvalType: // value for 'approvalType'
 *      extendedParameters: // value for 'extendedParameters'
 *      excludeThumbnails: // value for 'excludeThumbnails'
 *      pathBuilder: // value for 'pathBuilder'
 *   },
 * });
 */
export function useListApprovalsQuery(baseOptions?: Apollo.QueryHookOptions<ListApprovalsQuery, ListApprovalsQueryVariables>) {
        return Apollo.useQuery<ListApprovalsQuery, ListApprovalsQueryVariables>(ListApprovalsDocument, baseOptions);
      }
export function useListApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListApprovalsQuery, ListApprovalsQueryVariables>) {
          return Apollo.useLazyQuery<ListApprovalsQuery, ListApprovalsQueryVariables>(ListApprovalsDocument, baseOptions);
        }
export type ListApprovalsQueryHookResult = ReturnType<typeof useListApprovalsQuery>;
export type ListApprovalsLazyQueryHookResult = ReturnType<typeof useListApprovalsLazyQuery>;
export type ListApprovalsQueryResult = Apollo.QueryResult<ListApprovalsQuery, ListApprovalsQueryVariables>;